export default "__VITE_ASSET__BqNsOwnz__"